import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import { ReduxEntitySelect, ReduxInput, ReduxSelect, ReduxSwitch } from 'components/FormElements'
// constants
import { Forms } from 'constants/forms'
// graphql
import { RISK_TEMPLATE_SELECT_QUERY } from 'graphql/risk/queries'
// types
import { IOption } from 'components/FormElements/Select'
import { DashboardItemFunctionType, IRiskTemplate } from 'types/graphql'
// view components
import UploadImage from '../shared/UploadImage'
// utils
import { safeGetOr } from 'utils/fp'
import { map, pipe } from 'lodash/fp'

export const FN_TYPE_OPTIONS = [
  { label: 'Create record', value: DashboardItemFunctionType.CreateRisk },
  { label: 'Hyperlink', value: DashboardItemFunctionType.Hyperlink }
]

const FunctionFields: React.FC = () => {
  const functionType = useSelector((state) =>
    formValueSelector(Forms.DASHBOARD_WIDGET_SETTINGS_FORM)(state, 'functionType')
  )

  const getTemplatesOptions = pipe(
    safeGetOr<IRiskTemplate, any, IRiskTemplate[]>([], 'data.riskTemplates.data'),
    map<IRiskTemplate, IOption>(({ id, name, archived }) => ({ label: name, value: id, isDisabled: archived }))
  )

  return (
    <>
      <ReduxInput label='Title' name='title' />
      <ReduxInput label='Description' name='description' multiline />
      <UploadImage name='image' />
      <ReduxSelect label='Function type' name='functionType' options={FN_TYPE_OPTIONS} />
      {functionType.value === DashboardItemFunctionType.CreateRisk ? (
        <ReduxEntitySelect
          label='Target'
          name='riskTemplateId'
          getOptions={getTemplatesOptions}
          query={RISK_TEMPLATE_SELECT_QUERY}
          handleSearch={({ search, refetch }) => refetch({ filter: { name: search } })}
        />
      ) : (
        <ReduxInput label='Hyperlink' name='functionLink' />
      )}
      <ReduxSwitch label='Open in new window' name='openInWindow' />
      <ReduxInput name='width' label='Width (%)' type='number' />
      <ReduxInput name='height' label='Height (px)' type='number' />
    </>
  )
}

export default FunctionFields
